import React, { useEffect, useRef } from 'react';

export default function Html({
  className = 'h-full [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-4 [&_ol_li]:mb-1 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-4 [&_ul_li]:mb-2 [&_hr]:my-5 [&_h4]:text- [&_h4]:text-sm [&_h4]:font-semibold [&_h4]:uppercase [&_h4]:tracking-widest [&_h4]:text-primary [&_h4]:leading-4 [&_h4]:mb-5 [&_span]:instructions [&_*:last-child]:mb-0 [&_strong]:font-bold [&_b]:font-bold',
  html,
  ...rest
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const links = containerRef.current.querySelectorAll('a');
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'nofollow noopener noreferrer');
      });
    }
  }, [html]);

  return <div ref={containerRef} className={className} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
}
